import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
  SellerConfiguration,
} from '@savgroup-front-common/types';

import { buildUrl, prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

export interface GetSellerConfigurationQueryArgs {
  sellerId: string;
}

export const getSellerConfigurationRequest = ({
  sellerId,
}: GetSellerConfigurationQueryArgs): ApiRequestDescriptor => ({
  url: buildUrl(`${APIConfiguration.seller}sellers/${sellerId}/configuration`),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getSellerConfigurationQuery = async ({
  sellerId,
}: GetSellerConfigurationQueryArgs): Promise<
  BackResponseFailure | BackResponse<SellerConfiguration>
> => {
  try {
    return await executeQuery<BackResponse<SellerConfiguration>>(
      getSellerConfigurationRequest({ sellerId }),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
